module.exports = __webpack_public_path__ + "media/images/map/date-6e2dc29fc8b81440aed53b605a262403.svg";